import styled from 'styled-components';

const CompressedAirWrapper = styled.div``;

export { CompressedAirWrapper };
